module.exports = __webpack_public_path__ + "media/honey-icons/icon-clock-dca1f8d9.svg";